import { createContext, useContext, useState, type ReactNode } from 'react';
import { createPortal } from 'react-dom';

const Ctx = createContext<{
  slot: HTMLElement | null;
  setSlot: (el: HTMLElement | null) => void;
} | null>(null);

export function PageActionsProvider({ children }: { children: ReactNode }) {
  const [slot, setSlot] = useState<HTMLElement | null>(null);
  return <Ctx.Provider value={{ slot, setSlot }}>{children}</Ctx.Provider>;
}

/** The empty spot next to the page title that pages portal their buttons into. */
export function PageActionsSlot() {
  const ctx = useContext(Ctx);
  return <div ref={ctx?.setSlot ?? undefined} style={{ display: 'flex', gap: 8, alignItems: 'center', justifyContent: 'flex-end', flexWrap: 'wrap', flex: 1, minWidth: 0 }} />;
}

/** Renders children next to the page title. */
export function PageActions({ children }: { children?: ReactNode }) {
  const ctx = useContext(Ctx);
  if (!ctx?.slot || children == null) return null;
  return createPortal(children, ctx.slot);
}
